<div class="modal-content">
  <div class="modal__content">
    <div class="modal__header">
      <h3 class="h3 modal__title">{{ title }}</h3>
      <button
        (click)="onClickClose()"
        type="button"
        class="modal__close"
        data-bs-dismiss="modal"
        aria-label="Cerrar"
      >
        <img src="assets/images/icons/close.svg" alt="" />
      </button>
    </div>

    <div class="modal__body">
      <p *ngIf="text1">{{ text1 }}</p>
      <p *ngIf="text2" [innerHTML]="text2"></p>
    </div>

    <div class="modal__footer double-button">
      <button
        (click)="onClickCancel()"
        type="button"
        id=""
        class="btn-primary btn-large is-block"
      >
        {{ 'sharedModule.bkgVehicleWarningDialog.cancel' | translate }}
      </button>
      <button
        (click)="isProcessing ? null : onClickAccept()"
        type="button"
        [class.disabled]="isProcessing"
        id=""
        class="btn-primary btn-large is-block"
      >
        {{ 'servicesStep.bkgCarServices.add' | translate }}
      </button>
    </div>
  </div>
</div>
